"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var PartnersCtxItemImg = /** @class */ (function (_super) {
    __extends(PartnersCtxItemImg, _super);
    function PartnersCtxItemImg(props) {
        return _super.call(this, props) || this;
    }
    PartnersCtxItemImg.prototype.componentWillMount = function () {
        var _cursor = "default";
        var _showEdit = true;
        var _showDelete = true;
        if (this.props.mode === "select") {
            _cursor = "pointer";
            _showEdit = false;
            _showDelete = false;
        }
        this.setState({
            mCursor: _cursor,
            showDeleteButton: _showDelete,
            showEditButton: _showEdit
        });
    };
    PartnersCtxItemImg.prototype.editButtonClick = function () {
        if (this.props.mode === "edit") {
            if (this.props.onEditClick) {
                this.props.onEditClick(this.props.brand.key, this.props.dirName, this.props.fileName);
            }
        }
    };
    PartnersCtxItemImg.prototype.deleteButtonClick = function () {
        if (this.props.mode === "edit") {
            if (this.props.onDeleteClick) {
                this.props.onDeleteClick(this.props.brand.key, this.props.dirName, this.props.fileName);
            }
        }
    };
    PartnersCtxItemImg.prototype.selectImageClick = function () {
        if (this.props.mode === "select") {
            if (this.props.onSelectClick) {
                this.props.onSelectClick(this.props.brand.key, this.props.dirName, this.props.fileName);
            }
        }
    };
    PartnersCtxItemImg.prototype.getEditButtonRenderObject = function () {
        var cssStyle = {
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            borderRightColor: "transparent",
            borderTopColor: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "22px",
            height: "22px",
            backgroundColor: "#2E8B57",
            position: "absolute",
            right: "0px",
            top: "0px",
            boxSizing: "border-box",
            cursor: "pointer"
        };
        return (React.createElement(antd_1.Tooltip, { title: "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C" },
            React.createElement("div", { style: cssStyle, onClick: this.editButtonClick.bind(this) },
                React.createElement(antd_1.Icon, { type: "form", style: { color: "#FFFFFF" } }))));
    };
    PartnersCtxItemImg.prototype.getDeleteButtonRenderObject = function () {
        var cssStyle = {
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            borderLeftColor: "transparent",
            borderTopColor: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "22px",
            height: "22px",
            backgroundColor: "#6B0000",
            position: "absolute",
            left: "0px",
            top: "0px",
            boxSizing: "border-box",
            cursor: "pointer"
        };
        if (!this.state.showDeleteButton) {
            return null;
        }
        else {
            return (React.createElement(antd_1.Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" },
                React.createElement("div", { style: cssStyle, onClick: this.deleteButtonClick.bind(this) },
                    React.createElement(antd_1.Icon, { type: "delete", style: { color: "#FFFFFF" } }))));
        }
    };
    PartnersCtxItemImg.prototype.previewClick = function () {
        var win = window.open(this.getUrl(), '_blank');
        win.focus();
    };
    PartnersCtxItemImg.prototype.getPreviewButtonRenderObject = function () {
        var cssStyle = {
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            borderLeftColor: "transparent",
            borderBottomColor: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "22px",
            height: "22px",
            backgroundColor: "#003152",
            position: "absolute",
            left: "0px",
            bottom: "0px",
            boxSizing: "border-box",
            cursor: "pointer"
        };
        return (React.createElement(antd_1.Tooltip, { title: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440" },
            React.createElement("div", { style: cssStyle, onClick: this.previewClick.bind(this) },
                React.createElement(antd_1.Icon, { type: "eye", style: { color: "#FFFFFF" } }))));
    };
    PartnersCtxItemImg.prototype.getTitleRenderObject = function () {
        var cssStyle = {
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            borderLeftColor: "transparent",
            borderBottomColor: "transparent",
            borderRightColor: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "138px",
            backgroundColor: "#FFFFFF",
            position: "absolute",
            left: "22px",
            bottom: "0px",
            boxSizing: "border-box"
        };
        return (React.createElement(antd_1.Tooltip, { title: this.props.fileName },
            React.createElement("div", { style: cssStyle },
                React.createElement("div", { style: { overflow: "hidden", textOverflow: "ellipsis" } }, this.props.fileName))));
    };
    PartnersCtxItemImg.prototype.getUrl = function () {
        return "" + this.props.cdnUrl + this.props.brand.identity + "/" + this.props.dirName + "/" + this.props.fileName;
    };
    PartnersCtxItemImg.prototype.getImgBox = function () {
        var cssStyle = {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "160px",
            height: "138px",
            backgroundColor: "#FFFFFF",
            cursor: this.state.mCursor,
            position: "absolute",
            overflow: "hidden",
            textOverflow: "ellipsis",
            left: "0px",
            top: "0px"
        };
        return (React.createElement("div", { style: cssStyle, onClick: this.selectImageClick.bind(this) },
            React.createElement("img", { style: { maxWidth: "160px", maxHeight: "138px" }, src: this.getUrl(), alt: "" + this.props.fileName })));
    };
    PartnersCtxItemImg.prototype.render = function () {
        var cssStyle = {
            borderColor: "black",
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "160px",
            height: "160px",
            marginLeft: "5px",
            marginTop: "5px",
            marginRight: "0px",
            marginBottom: "5px",
            backgroundColor: "#FFFFFF",
            cursor: this.state.mCursor,
            position: "relative",
            overflow: "hidden",
            textOverflow: "ellipsis"
        };
        return (React.createElement("div", { style: cssStyle },
            this.getImgBox(),
            this.getTitleRenderObject(),
            this.getEditButtonRenderObject(),
            this.getDeleteButtonRenderObject(),
            this.getPreviewButtonRenderObject()));
    };
    return PartnersCtxItemImg;
}(React.Component));
exports.default = PartnersCtxItemImg;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_images/ui/component/controls/PartnersCtxItemImg.tsx
// module id = 2465
// module chunks = 0